/**
 * 腾讯域：T0广告看板 - 自定义账户集合 API 服务（CLAUDE.md §前端 API 服务层 — 按域分目录）。
 *
 * 与后端 Pydantic 模型 src.tencent.dtos.custom_account_set 对齐。
 *   - GET    /api/v1/tencent/custom-account-set          → 全部集合（读，任意登录用户）
 *   - POST   /api/v1/tencent/custom-account-set          → 新建集合（写，tencent:t0-dashboard 可编辑组）
 *   - PUT    /api/v1/tencent/custom-account-set/{id}     → 更新名称/账户列表（写）
 *   - DELETE /api/v1/tencent/custom-account-set/{id}     → 软删集合（写）
 *
 * 写操作返回保存后全量列表（后端口径），前端直接替换列表状态。
 */

import { request } from "../apiClient";

/** 自定义账户集合单行（与后端 CustomAccountSetRecord 对齐）。 */
export interface CustomAccountSetRecord {
  id: number;
  set_name: string;
  account_ids: string[];
  created_time: string;
  updated_time: string;
}

/** 新建 / 更新入参（与后端 CustomAccountSetUpsertBody 对齐）。 */
export interface CustomAccountSetUpsertBody {
  set_name: string;
  account_ids: string[];
}

/** 取全部自定义账户集合（按 id 升序；空表返回 []）。 */
export async function listCustomAccountSets(): Promise<CustomAccountSetRecord[]> {
  const data = await request<CustomAccountSetRecord[] | null>(
    "/api/v1/tencent/custom-account-set",
  );
  return data ?? [];
}

/** 新建集合；返回保存后全量列表。 */
export async function createCustomAccountSet(
  body: CustomAccountSetUpsertBody,
): Promise<CustomAccountSetRecord[]> {
  const data = await request<CustomAccountSetRecord[] | null>(
    "/api/v1/tencent/custom-account-set",
    { method: "POST", body },
  );
  return data ?? [];
}

/** 更新指定集合的名称与账户列表；返回保存后全量列表。 */
export async function updateCustomAccountSet(
  setId: number,
  body: CustomAccountSetUpsertBody,
): Promise<CustomAccountSetRecord[]> {
  const data = await request<CustomAccountSetRecord[] | null>(
    `/api/v1/tencent/custom-account-set/${setId}`,
    { method: "PUT", body },
  );
  return data ?? [];
}

/** 软删指定集合；返回保存后全量列表。 */
export async function deleteCustomAccountSet(
  setId: number,
): Promise<CustomAccountSetRecord[]> {
  const data = await request<CustomAccountSetRecord[] | null>(
    `/api/v1/tencent/custom-account-set/${setId}`,
    { method: "DELETE" },
  );
  return data ?? [];
}
